export var buildNumber = "516342";



//////////////////
// WEBPACK FOOTER
// ./src/buildNumber.ts
// module id = 985
// module chunks = 3